/**
 * `/tenants` — Link Admin tenants section LAYOUT route.
 *
 * Phase 6 originally combined the list + section layout in this file (set
 * `component: TenantsListScreen` directly). That broke nested routes — the
 * parent `component` always rendered, so `/tenants/new` and
 * `/tenants/{id}/brand` showed the list instead of their children.
 *
 * Quick fix 260426-n91 splits this into:
 *   - `_auth.tenants.tsx`        — layout-only, renders `<Outlet />`
 *   - `_auth.tenants.index.tsx`  — owns the list + validateSearch
 *
 * Breadcrumb staticData stays here so it covers every nested route under
 * /tenants without each child re-declaring it.
 */
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/tenants")({
  staticData: {
    breadcrumb: { labelKey: "nav.tenants" },
  },
  component: Outlet,
});
